import './GibButtons.css';
import Button from "react-bootstrap/Button"
import {Row, Col} from "react-bootstrap";
import React, {Component} from "react";

// #DAD5CB
// #109E30
// #54D170
// #2D6B00
// #5B1E78
// #49109E
// #2d422b
// #D97F4E



class GibButtons extends Component {


    render() {
        const isMobile = window.innerWidth <= 500;
        const socialIconsSize = (60).toString();
        return (<div>
            <style type="text/css">
                <style type="text/css">
                    {`
                        .btn-flat-purple {
                          background-color: #2d422b99;
                          color: white;
                          border-radius: 0rem;
                        }
                        .btn-flat-orange {
                          background-color: #2d422bCC;
                          color: white;
                          border-radius: 0rem;
                        }
                        .btn-flat-green {
                          background-color: #2d422bFF;
                          color: white;
                          border-radius: 0rem;
                        }

                        .btn-xxl {
                          padding: 1rem 1rem;
                          font-size: 1.2rem;
                          font-weight: bold;
                        }

                        `}
                </style>
            </style>
            <Row style={{marginTop: '5px'}}>
                <Col>
                    <Button
                        href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=4M5H5DRRD8WNQ&source=url"
                        variant="flat-purple"
                        size="xxl" block>
                        PODARUJ 15 zł
                    </Button>
                </Col>
            </Row>
            <Row style={{marginTop: '5px'}}>
                <Col>
                    <Button
                        href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=4M5H5DRRD8WNQ&source=url"
                        variant="flat-orange"
                        size="xxl" block>
                        PODARUJ 30 zł
                    </Button>
                </Col>
            </Row>
            <Row style={{marginTop: '5px'}}>
                <Col>
                    <Button
                        href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=4M5H5DRRD8WNQ&source=url"
                        variant="flat-green"
                        size="xxl" block>
                        PODARUJ 50 zł
                    </Button>
                </Col>
            </Row>
        </div>);
    }
}

export default GibButtons;